import { render } from "./BankIdV6Login.vue?vue&type=template&id=00ef5f2f&scoped=true&ts=true"
import script from "./BankIdV6Login.vue?vue&type=script&lang=ts"
export * from "./BankIdV6Login.vue?vue&type=script&lang=ts"

import "./BankIdV6Login.vue?vue&type=style&index=0&id=00ef5f2f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ef5f2f"]])

export default __exports__